import createHash from "create-hash";
import createKeccakHash from "keccak";
export const keccak256 = (msg) => createKeccakHash("keccak256").update(msg).digest();
export const ripemd160 = (msg) => createHash("rmd160").update(msg).digest();
export const sha256 = (msg) => createHash("sha256").update(msg).digest();
export const hash160 = (publicKey) => ripemd160(sha256(publicKey));
//# sourceMappingURL=hash.js.map